import { forwardRef } from "react"

import useIsDesktop from "@hooks/useIsDesktop"

import { faIcon } from "@utils/faIcon"

import { Button, IconButton } from "@atoms"

import { ViewBarFiltersButtonProps } from "./ViewBarFiltersButton.types"

function ViewBarFiltersButton(props: ViewBarFiltersButtonProps, ref: React.Ref<HTMLButtonElement>) {
    const { appliedFiltersCount = 0, onClick, isDisabled, isPressed, ...rest } = props

    const isDesktop = useIsDesktop()

    // Button and IconButton require onClick; as a Popover.Trigger child the real handler arrives from Radix.
    const handleClick = onClick ?? (() => {})

    const icon = faIcon({ name: "bars-filter", style: "regular" })

    if (isDesktop) {
        return (
            <Button
                {...rest}
                ref={ref}
                size="lg"
                variant="ghost"
                leftIcon={icon}
                onClick={handleClick}
                noDebounce={true}
                isDisabled={isDisabled}
                isPressed={isPressed}
            >
                Filters
            </Button>
        )
    } else if (appliedFiltersCount > 0) {
        return (
            <Button
                {...rest}
                ref={ref}
                size="lg"
                variant="ghost"
                leftIcon={icon}
                onClick={handleClick}
                noDebounce={true}
                isDisabled={isDisabled}
                isPressed={isPressed}
                aria-label={`Filters (${appliedFiltersCount})`}
            >
                {appliedFiltersCount}
            </Button>
        )
    } else {
        return (
            <IconButton
                {...rest}
                ref={ref}
                size="lg"
                variant="ghost"
                icon={icon}
                onClick={handleClick}
                noDebounce={true}
                isDisabled={isDisabled}
                isPressed={isPressed}
                aria-label="Filters"
            />
        )
    }
}

export default forwardRef(ViewBarFiltersButton)
